import { Color } from "@repo/app-types/constants/colors";
import {
  type KeywordAnalysis,
  KeywordAnalysisType,
} from "@repo/app-types/entities/keyword";
import { Label } from "@repo/ui/Label/label";
import { Size } from "@repo/ui/helpers/helpers";
import { type FC, Fragment } from "react";
import { InsightBar } from "../insightBar.js";

interface KeywordAnalysisCard {
  competitorName: string;
  keywordAnalysis: KeywordAnalysis;
}

const keywordAnalysisTypeToTitlePrefix = {
  [KeywordAnalysisType.COMPETITIVE_STRENGTH]: "Strengths against ",
  [KeywordAnalysisType.COMPETITIVE_WEAKNESS]: "Weaknesses against ",
};

export const KeywordAnalysisCard: FC<KeywordAnalysisCard> = ({
  keywordAnalysis,
  competitorName,
}) => {
  const title = `${
    keywordAnalysisTypeToTitlePrefix[keywordAnalysis.type]
  } ${competitorName}`;

  const renderAnalysisValues = () => {
    // Edge case where LLM doesn't produce any analyses
    if (keywordAnalysis.values.length === 0) {
      return (
        <div className="col-span-4 flex items-center">
          Insights will appear here as more interviews are completed.
        </div>
      );
    }

    return keywordAnalysis.values.map((value, index) => {
      return (
        <Fragment key={`keyword-analysis-${competitorName}-${index}`}>
          <div className="col-span-4 flex items-center">
            <span>{value.label}</span>
          </div>
          <div className="col-span-1 flex rounded-md pt-2">
            <InsightBar
              color={
                keywordAnalysis.type ===
                KeywordAnalysisType.COMPETITIVE_STRENGTH
                  ? Color.Green
                  : Color.Red
              }
              percentageWidth={(value.score / 5) * 100}
            />
          </div>
        </Fragment>
      );
    });
  };

  return (
    <div>
      <div className="grid grid-cols-5 gap-3">
        <div className="col-span-4 flex">
          <Label size={Size.SMALL}>{title}</Label>
        </div>
        <div className="col-span-1">
          <Label size={Size.SMALL}>Influence</Label>
        </div>
        {renderAnalysisValues()}
      </div>
    </div>
  );
};
